import { render, staticRenderFns } from "./AssetPendingRequests.vue?vue&type=template&id=4888fa2f&scoped=true&"
import script from "./AssetPendingRequests.vue?vue&type=script&lang=js&"
export * from "./AssetPendingRequests.vue?vue&type=script&lang=js&"
import style0 from "./AssetPendingRequests.vue?vue&type=style&index=0&id=4888fa2f&lang=scss&scoped=true&"
import style1 from "./AssetPendingRequests.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888fa2f",
  null
  
)

export default component.exports